import { cn } from "@omni/utils/styles";

import { GuaranteeNotice } from "@/components/Product/GuaranteeNotice/guaranteeNotice";

const GuaranteeNoticeCTA = () => {
    return (
        <div
            className={cn(
                "tw:flex tw:flex-col tw:mb-3 tw-text-center tw:self-center tw:relative tw:md:absolute tw:md:right-0"
            )}
        >
            <GuaranteeNotice.Label />
        </div>
    );
};

export { GuaranteeNoticeCTA };
